import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-user-ticket',
  templateUrl: './user-ticket.page.html',
  styleUrls: ['./user-ticket.page.scss'],
})
export class UserTicketPage implements OnInit {

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {
  }

  public onAccept = () => this.modalCtrl.dismiss();

}
